import { BI_BASE_URL } from '@app/contstants/endpoints';
import { api } from '@app/utils/api';
import { useQuery } from '@tanstack/react-query';
import { TeamQuarterlyHistoryResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  year: number;
};

const getTeamQuarterlyHistory = async (params: Params): Promise<TeamQuarterlyHistoryResponse> => {
  const { data } = await api.get<TeamQuarterlyHistoryResponse>(
    `${BI_BASE_URL}/managers/team/quarterly/history`,
    { params }
  );
  return data ?? [];
};

export const useGetTeamQuarterlyHistory = ({ year }: Params) => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.TEAM_QUARTERLY_HISTORY, year],
    queryFn: () => getTeamQuarterlyHistory({ year }),
  });
};
